/**
 * jobCategoryApi — AISC §1.7.0 §3.2 project categorization + customer waiver.
 *
 * Backed by sfm-web-backend src/routes/jobCategory.js.
 */

import ApiCall from "./apicall";

export const FABRICATION_CATEGORIES = ["SIMPLE", "CONVENTIONAL", "COMPLEXED"];

export async function setJobCategory(jobId, fabrication_category, rationale = "") {
  const res = await ApiCall.patch(`/job/${jobId}/category`, {
    fabrication_category,
    rationale,
  });
  return res.data;
}

export async function setJobCustomerWaiver(jobId, params) {
  const {
    customer_drawing_approval_waived,
    customer_waiver_doc_id,
    rationale = "",
  } = params || {};
  const res = await ApiCall.post(`/job/${jobId}/customer-waiver`, {
    customer_drawing_approval_waived,
    customer_waiver_doc_id,
    rationale,
  });
  return res.data;
}

/**
 * Returns descriptive text for a fabrication category badge.
 * Mirrors the AISC §1.7.0 §3.2 examples.
 */
export function describeFabricationCategory(category) {
  switch (String(category || "").toUpperCase()) {
    case "SIMPLE":
      return "Standard frame clips, basic prep, beam-to-column bearing. Examples: entries, joist+deck, flat roof.";
    case "CONVENTIONAL":
      return "Moment connections, gusset plates, base plates, K-braces. Examples: 2-5 story office/warehouse, schools, industrial stairs.";
    case "COMPLEXED":
      return "Cambered beams, trusses, AESS, custom frames, hip/valley roof, intricate geometry.";
    default:
      return "Not yet categorized — Operations sets after detailer completes drawings.";
  }
}
